<script>
    import {accordion} from "../lib/accordion";
    import {clickOutside} from "../lib/clickOutside";
    import app from "../stores/app";
    import user from "../stores/user";
    import {router} from '../lib/Router/Router.svelte';
    import AppIcon from "./icons/AppIcon.svelte";
    import A from "../lib/Router/A.svelte";
    // import Icon from "./Icon.svelte";

    let path = "";
    let activePath = '';

    let menu = [
        {
            id: 'dashboard',
            name: 'DASHBOARD',
            link: `/app`,
            icon: 'dashboard'
        },
        {
            id: 'task',
            name: 'ΕΡΓΑΣΙΕΣ',
            link: `/app/task`,
            icon: 'tasks'
        },
        {
            id: 'project',
            name: 'PROJECTS',
            link: `/app/project`,
            icon: 'projects'
        },
        {
            id: 'services',
            name: 'ΥΠΗΡΕΣΙΕΣ',
            link: `/app/services`,
            icon: 'services'
        },
        {
            id: 'charges',
            name: 'ΧΡΕΩΣΕΙΣ',
            link: `/app/charges`,
            icon: 'charges'
        },
        {
            id: 'client',
            name: 'ΠΕΛΑΤΕΣ',
            link: `/app/client`,
            icon: 'clients'
        },
        {
            id: 'notification',
            name: 'ΕΙΔΟΠΟΙΗΣΕΙΣ',
            link: `/app/notifications`,
            icon: 'notifications'
        },
        {
            id: 'settings',
            name: 'ΡΥΘΜΙΣΕΙΣ',
            icon: 'settings',
            menu: [
                // {
                //     id: 'workspace',
                //     name: 'ΧΩΡΟΣ ΕΡΓΑΣΙΑΣ',
                //     link: `/app/workspace`,
                // },
                {
                    id: 'ws-service',
                    name: 'ΕΙΔΗ ΥΠΗΡΕΣΙΩΝ',
                    link: `/app/ws-service`,
                },
                {
                    id: 'users',
                    name: 'ΧΡΗΣΤΕΣ',
                    link: `/app/users`,
                },
                {
                    id: 'my-account',
                    name: 'Ο ΛΟΓΑΡΙΑΣΜΟΣ ΜΟΥ',
                    link: `/app/my-account`,
                }
            ],
            menu_expanded: false,
        }
    ];

    const pathFromLink = (link) => {
        return link.replace(window.location.origin, "");
    }

    const toggleMenu = (menu_id) => {
        menu.map(item => {
            if (item.menu) {
                if (item.id === menu_id) {
                    item.menu_expanded = !item.menu_expanded;
                } else {
                    item.menu_expanded = false;
                }
            }
        });
        menu = menu;
    }

    const onMenuItemClick = (event) => {
        event.preventDefault();
        let a = null;
        if (event.target.href) {
            a = event.target;
        } else {
            a = event.target.closest('a');
        }
        let link = pathFromLink(a.href);
        $app.menuExpanded = 0;
        activePath = link;
        router.go(link)();
    }

    const collapseMenu = () => {
        if ($app.menuExpanded > 0) {
            $app.menuExpanded--;
        }
    }

    activePath = pathFromLink(window.location.href);

    // $: if (path !== router.url) {
    $: if (path !== activePath) {
        // expand current menu
        let arr = activePath.split("/");
        menu.map(item => {
            if (item.menu) {
                item.menu.map(subItem => {
                    if (arr.indexOf(subItem.id) > -1) {
                        item.menu_expanded = true;
                    }
                });
            }
        });
        path = activePath;
    }

</script>

<aside class:expanded={ $app.menuExpanded > 0 }>
    <div class="app-header">
        header
    </div>

    <div class="app-menu" use:clickOutside on:click_outside="{ collapseMenu }">
        {#each menu as item}
            {#if item.menu}
                <div class="app-menu-dropdown">
                    <div class="app-menu-item" on:click="{ () => toggleMenu(item.id) }">
                        <div class="icon">
                            <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu">
                        </div>
                        <div class="caption">{ item.name }</div>
                    </div>
                    <!--{#if item.menu_expanded}-->
                    <div class="app-menu-item-dropdown" use:accordion={item.menu_expanded}>
                        {#each item.menu as subItem}
                            <a href="{ subItem.link }" class="app-menu-item"
                               class:link-active={ path === subItem.link } on:click="{ onMenuItemClick }">
                                <span class="caption">{ subItem.name }</span>
                            </a>
                        {/each}
                    </div>
                    <!--{/if}-->
                </div>
            {:else}
                <a href="{ item.link }" class="app-menu-item" class:link-active={ path === item.link }
                   on:click="{ onMenuItemClick }">
                        <span class="icon">
                            <img src="/assets/icons/navigation/{ item.icon }.svg" alt="menu">
                        </span>
                    <span class="caption">{ item.name }</span>
                </a>
                <!--                    <A href="{ item.link }" class="app-menu-item" useActive>-->
                <!--                        <span class="icon"><Icon name="{ item.icon }" size="16"/></span>-->
                <!--                        <span class="caption">{ item.name }</span>-->
                <!--                    </A>-->
            {/if}
        {/each}
    </div>
</aside>


<style>
    aside {
        position: fixed;
        height: 100vh;
        transition: .3s all ease;
        z-index: 5000;
    }

    .app-header {
        height: var(--header-height);
    }

    .app-menu {
        height: 100%;
        background: #fff;
        border-left: 5px solid #d4d5d5;
        /*border-right: 1px solid #c6d2d9;*/
        -webkit-box-shadow: 2px 0 4px rgba(0, 0, 0, .08);
        box-shadow: 2px 0 4px rgba(0, 0, 0, .08);
        transition: .3s all ease;
    }

    .app-menu-dropdown {
        position: relative;
        /*display: none;*/
    }

    .app-menu-dropdown .app-menu-item-dropdown {

    }

    .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
        padding-left: 50px;
    }

    .app-menu .workspace {
        border-bottom: 1px solid #dddde0;
    }


    .app-menu .workspace .current {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #5d5a68;
        cursor: pointer;
    }

    .app-menu .workspace .current:hover {
        background: #f9f9f9;
    }

    .app-menu .workspace .current .name {
        font-size: 1rem;
        font-weight: 500;
        padding: 15px 15px;
    }

    .app-menu .workspace .current .icon {
        padding: 0 15px 0 0;
    }

    .app-menu .workspace .group {

    }

    .app-menu .workspace .group .group-item a {
        display: block;
        padding: 10px 15px;
    }

    .app-menu .workspace .group .group-item a:hover {
        background: #f9f9f9;
    }

    @media (max-width: 576px) {
        aside {
            width: 100%;
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 577px) and (max-width: 999px) {
        aside {
            width: var(--aside-width);
            left: -100%;
        }

        aside.expanded {
            left: 0;
        }
    }

    @media (min-width: 1000px) and (max-width: 1024px) {
        aside {
            width: 50px;
        }

        aside:hover, aside.expanded {
            width: var(--aside-width);
        }

        .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: none;
        }

        aside:hover .app-menu-dropdown .app-menu-item-dropdown .app-menu-item,
        aside.expanded .app-menu-dropdown .app-menu-item-dropdown .app-menu-item {
            display: block;
        }
    }

    @media (min-width: 1025px) {
        aside {
            width: var(--aside-width);
        }
    }


    :global(.app-menu-item) {
        display: flex;
        align-items: center;
        color: #6a6c6f;
        border-left: 5px solid #d4d5d5;
        white-space: nowrap;
        padding: 15px;
        margin-left: -5px;
        cursor: pointer;
        overflow: hidden;
    }

    :global(.app-menu-item .icon) {
        display: block;
        min-width: 16px;
        line-height: 1;
        margin-right: 15px;
    }

    :global(.app-menu-item .caption) {
        display: block;
    }

    :global(.app-menu-item:hover) {
        color: #6a6c6f;
        background: #f6f7fa;
        /*border-left-color: #0277bd;*/
    }

    :global(.app-menu-item.link-active) {
        color: #188ae2;
        border-left-color: #188ae2;
    }

    :global(.app-menu-item.link-active):after {
        position: absolute;
        content: " ";
        display: block;
        clear: both;
        width: 0;
        height: 0;
        border-style: solid;
        /*border-width: 25px 0 25px 5px;*/
        border-width: 10px 0 10px 9px;
        border-color: transparent transparent transparent #188ae2;
        left: 0;
    }
</style>